var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSaurDataDico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "178px",
    height: "28px",
    viewBox: "0 0 178 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accueil---Recherche",
    transform: "translate(-36.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav/header",
    transform: "translate(0.193975, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(36.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms/logoSAUR-white-Old",
    transform: "translate(86.000000, -0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("text", {
    id: "IODA",
    fontFamily: "Montserrat-Bold, Montserrat",
    fontSize: 13,
    fontWeight: "bold",
    "line-spacing": 15
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18,
    y: 20
  }, "DATADICO")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(1.500000, 12.000000) rotate(-270.000000) translate(-1.500000, -12.000000) ",
    x: -10.5,
    y: 10.5,
    width: 24,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,18.9 L29,15.9 L29.1,15.9 C30.4,17.3 32,19 33.7,19 C34.7,19 35.7,18.5 35.7,17.3 C35.7,16.1 34.6,15.7 32.6,15 C30.2,14.2 28.7,13.1 28.7,11.2 C28.7,9 30.6,7.7 33.4,7.7 C34.5,7.7 36,8 37.5,8.6 L37.5,11.5 L37.5,11.5 C36.3,10 34.8,8.6 33.2,8.6 C32.2,8.6 31.3,9.1 31.3,10.1 C31.3,11.3 32.6,11.6 34.4,12.3 C37.1,13.2 38.1,14.3 38.1,16.1 C38.1,18.7 35.9,19.9 33.6,19.9 C32.3,19.9 30.8,19.6 29,18.9",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3,16.3 C39.3,14.4 40.5,13.2 42.5,12.7 C44.7,12.2 46,13.4 46,13.4 L46,13.5 C43.7,13.2 42.5,14.4 42.5,15.9 C42.5,17.3 43.5,18.3 44.8,18.3 C45.5,18.3 46.2,17.9 46.7,17.3 L46.7,11.5 C46.7,9.8 46,8.8 45.1,8.8 C43.7,8.8 40.8,11.1 40.3,11.7 L40.2,11.7 L40.2,8.7 C42.1,8.1 44,7.8 45.2,7.8 C48.1,7.8 49.5,9.3 49.5,11.6 L49.5,16.9 C49.5,18.2 50,18.7 51,18.3 L51,18.4 C50.8,19.3 50,20 48.8,20 C47.6,20 46.8,19.3 46.6,18.2 C45.9,19.1 44.8,20 43.1,20 C40.6,19.9 39.3,18.1 39.3,16.3",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8,17.6 C59.8,17.3 59.7,16.6 59.7,16.1 L59.7,11.5 C59.7,10 59.2,8.5 59.1,8 L59.1,7.9 L62.6,7.9 L62.6,16.1 C62.6,17.6 63.1,19.2 63.2,19.6 L63.2,19.7 L60.3,19.7 C60.1,19.3 59.9,18.5 59.8,17.6 M52.1,15.9 L52.1,11.5 C52.1,10 51.6,8.5 51.5,8 L51.5,7.9 L55,7.9 L55,15.5 C55,17.3 56.1,17.9 57.2,17.9 C57.7,17.9 58.2,17.8 58.7,17.5 L58.8,17.6 C58.8,17.6 58.1,19.8 55.9,19.8 C53.6,19.9 52.1,18.3 52.1,15.9",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9,10.2 L68.9,10.2 C68.8,10.1 69.5,7.7 71.6,7.6 C72,7.6 72.5,7.7 73,7.8 L72.5,11.1 L72.4,11.1 C71.5,10.3 70.2,9.7 68.9,10.2 L68.9,10.2 Z M64.6,19.6 C64.7,19.2 65.2,17.7 65.2,16.1 L65.2,11.5 C65.2,10 64.7,8.4 64.6,8 L64.6,7.9 L68.1,7.9 L68.1,16.1 C68.1,17.6 68.6,19.2 68.6,19.6 L68.6,19.7 L64.6,19.6 Z",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7,14.8 L14.1,14.8 C15.3,14.8 16.5,15.1 17.5,15.7 C17.2,14.1 15.8,12.8 14.1,12.8 L9.7,12.8 C8.5,12.8 7.3,12.5 6.3,11.9 C6.6,13.6 8,14.8 9.7,14.8",
    id: "Fill-9",
    fill: "#00B2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7,19.8 L14.1,19.8 C15.8,19.8 17.2,18.6 17.5,16.9 C16.5,17.5 15.3,17.8 14.1,17.8 L9.7,17.8 C8.5,17.8 7.3,17.5 6.3,16.9 C6.6,18.5 8,19.8 9.7,19.8",
    id: "Fill-11",
    fill: "#00B2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,9.9 C15.3,9.9 16.5,10.2 17.5,10.8 C17.2,9.2 15.8,7.9 14.1,7.9 L9.7,7.9 C8,7.9 6.6,9.1 6.3,10.8 C7.3,10.2 8.5,9.9 9.7,9.9 L14.1,9.9 Z",
    id: "Fill-13",
    fill: "#00B2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4,25.6 C6.2,25.6 3,25 0.1,24 C2.5,26.2 5.8,27.6 9.4,27.6 L14.5,27.6 C18.1,27.6 21.3,26.2 23.8,24 C20.9,25 17.8,25.6 14.5,25.6 L9.4,25.6 Z",
    id: "Fill-15",
    fill: "#00B2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,2 C17.6,2 20.8,2.6 23.7,3.6 C21.3,1.4 18,0 14.4,0 L9.3,0 C5.7,0 2.5,1.4 0,3.6 C2.9,2.6 6,2 9.3,2 L14.4,2 Z",
    id: "Fill-17",
    fill: "#00B2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,4 L9.7,4 C7.3,4 5.2,5.2 4,7.1 C5.7,6.4 7.5,6 9.4,6 L14.5,6 C16.4,6 18.2,6.4 19.9,7.1 C18.6,5.2 16.5,4 14.1,4",
    id: "Fill-19",
    fill: "#00B2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7,23.7 L14.1,23.7 C16.5,23.7 18.6,22.5 19.8,20.6 C18.1,21.3 16.3,21.7 14.4,21.7 L9.3,21.7 C7.4,21.7 5.6,21.3 3.9,20.6 C5.2,22.5 7.3,23.7 9.7,23.7",
    id: "Fill-21",
    fill: "#00B2A9"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSaurDataDico);
export default __webpack_public_path__ + "static/media/LogoSaurDataDico.5ff73cfb1d19a8c82bd9532cbcdfd59c.svg";
export { ForwardRef as ReactComponent };